var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"notification"},[_c('div',{staticClass:"notification-body box",class:_vm.notificationType},[_c('h3',[_vm._v(_vm._s(_vm.headText))]),_c('p',[_vm._v(_vm._s(_vm.bodyText))])])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }